<template>
  <v-card>
    <v-card-title>
      <div>
        <div class="headline">Permitted Intermediaries</div>
      </div>
      <v-spacer></v-spacer>
      <v-flex xs6>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-flex>
    </v-card-title>
    <v-flex xs12 class="mt-3">
      <message :messages="messages"></message>
    </v-flex>
    <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="intermediary" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
      <template slot="items" slot-scope="props">
        <td>{{ props.item.intermediary }}</td>
        <td class="text-xs-left">{{ props.item.intermediaryName }}</td>
        <td class="text-xs-right">
          <table-action :rowData="props" remove @remove="doPromptRemove(props.item)" :loading="loading"></table-action>
        </td>
      </template>
    </v-data-table>
    <v-card-text>
      <v-btn slot="activator" color="primary" dark class="mb-2" @click="doNew()">
        Permit Intermediary
        <v-icon right>mdi-account</v-icon>
      </v-btn>
    </v-card-text>
    <v-dialog v-model="addIntermediaryDialog" max-width="600px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">Permit Intermediary for Campaign</span>
        </v-card-title>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs12>
                <v-autocomplete :label="labels.intermediary" v-model="intermediaryCampaignForm.intermediary" :items="intermediaryList" item-text="label" item-value="value" :error-messages="errors.collect('intermediary')" data-vv-name="intermediary" :data-vv-as="labels.intermediary" v-validate="'required'" :loading="intermediaryLoading"></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click.native="doClose">Cancel</v-btn>
          <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure that you want to delete the selected Permitted Intermediary?
      <div class="title">{{deleteIntermediaryCampaign}}</div>
    </confirm>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'

export default {
  data() {
    return {
      headers: [
        { text: 'Intermediary Code', align: 'left', value: 'intermediary', sortable: false },
        { text: 'Intermediary Name', align: 'left', value: 'intermediaryName', sortable: false },
        TableConst.tableActionHeader
      ],
      labels: {
        intermediary: 'Intermediary*'
      },
      intermediaryCampaignForm: {
        campaign: undefined,
        intermediary: undefined
      },
      totalItems: 0,
      loading: false,
      items: [],
      addIntermediaryDialog: false,
      intermediaryLoading: false,
      intermediaryList: [],
      promptRemove: false,
      selectedIntermediaryCampaign: undefined,
      deleteIntermediaryCampaign: ''
    }
  },
  methods: {
    async doInit() {
      this.intermediaryCampaignForm.campaign = this.campaign
      await this.queryIntermediaryCampaign()
    },
    async queryIntermediaryCampaign() {
      const apiURI = this.$store.state.promotionManagement.campaign.menu.campaignIntermediaries
      if (apiURI) {
        try {
          this.loading = true
          const expand = {
            campaign: this.campaign
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              // Format the data here
              this.items = []
              data.map((intermediaryCampaign) => {
                const convertIntermediaryCampaign = {
                  campaign: intermediaryCampaign.campaign,
                  campaignDesc: intermediaryCampaign.campaignDesc,
                  intermediary: intermediaryCampaign.intermediary,
                  intermediaryName: intermediaryCampaign.intermediaryName
                }
                this.items.push(convertIntermediaryCampaign)
              })
            } else {
              this.items = []
            }
          }
          this.loading = false
        } catch (err) {
          throw err
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async getIntermediaries() {
      this.intermediaryLoading = true
      if (this.$store.state.promotionManagement.campaign.intermediaryList && this.$store.state.promotionManagement.campaign.intermediaryList.length > 0) {
        let result = []
        result = this.$store.state.promotionManagement.campaign.intermediaryList
        // Remove those that already permitted
        result = result.filter(intermediary => {
          for (let permittedInter of this.items) {
            if (permittedInter.intermediary === intermediary.value) {
              return false
            }
          }
          return true
        })
        this.intermediaryList = result
      } else {
        this.intermediaryList = []
      }
      this.intermediaryLoading = false
    },
    doSave() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.doCreate()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doNew() {
      this.resetMessages()
      this.intermediaryCampaignForm.intermediary = undefined
      this.addIntermediaryDialog = true
      this.getIntermediaries()
    },
    async doCreate() {
      const apiURI = this.$store.state.promotionManagement.campaign.menu.campaignIntermediaryCreate
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.intermediaryCampaignForm)
          const { data } = result
          if (data) {
            // Show message via notify
            this.notify(data)
            this.doClose()
            // Fetch list again
            this.queryIntermediaryCampaign()
          }
          this.submitting = false
        } catch (err) {
          console.log(err)
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doClose() {
      this.resetMessages()
      this.intermediaryCampaignForm.intermediary = undefined
      this.addIntermediaryDialog = false
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedIntermediaryCampaign = data
        this.deleteIntermediaryCampaign = data.intermediary + ' - ' + data.intermediaryName
      }
    },
    async doRemove() {
      const apiURI = this.$store.state.promotionManagement.campaign.menu.campaignIntermediaryDelete
      if (apiURI) {
        this.loading = true
        const expand = {
          campaign: this.campaign,
          intermediary: this.selectedIntermediaryCampaign.intermediary
        }
        try {
          const result = await this.$http.post(apiURI, expand)
          this.notify(result.data)
          // Reinit
          this.queryIntermediaryCampaign()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    }
  },
  props: {
    campaign: {
      type: String,
      default: ''
    }
  },
  created() {
    this.doInit()
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style lang="scss">
</style>
